var map = {
	"./approved.png": "1e10",
	"./arrow-next.png": "e53c",
	"./arrow-prev.png": "27d1",
	"./background.png": "887c",
	"./button-get-started.png": "d362",
	"./dot-active.png": "ee76",
	"./dot-inactive.png": "6688",
	"./slide-1-sharpen-patient-2.png": "ac0d",
	"./slide-1-sharpen-patient.png": "c35b",
	"./slide-2-explore-an-interactive-2.png": "4d6e",
	"./slide-2-explore-an-interactive.png": "7148",
	"./slide-3-get-to-know-2.png": "808c",
	"./slide-3-get-to-know.png": "10f3",
	"./slide-4-understand-how-to-2.png": "36ee",
	"./slide-4-understand-how-to.png": "883f",
	"./slide-5-recognize-key-initiation-2.png": "4313",
	"./slide-5-recognize-key-initiation.png": "4cea",
	"./slide-6-guide-patients-experiencing-2.png": "1ad9",
	"./slide-6-guide-patients-experiencing.png": "01c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f031";